import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HomePage.css';
import RecipeDetail from './RecipeDetail';
import Footer from './Footer';
import logo from '../assets/yemek.png.png';

const recipeDetailsData = [
  {
    id: 1,
    title: "5 Dakikada Kupta Çikolatalı Tatlı",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80",
    time: '5 dk',
    details: {
      summary: "Tatlı krizleri için sadece 5 dakikada hazırlayabileceğiniz kolay bir tarif: Kupta çikolatalı tatlı! Hem şık sunum hem de yoğun çikolata tadı bir arada.",
      ingredients: [
        "1 su bardağı süt",
        "1 yemek kaşığı kakao",
        "1 yemek kaşığı nişasta",
        "2 yemek kaşığı toz şeker",
        "40 g bitter çikolata (yarım paket)",
        "Üzeri için: muz dilimleri, fındık, hindistan cevizi"
      ],
      instructions: [
        "Kakao, nişasta, şeker ve sütü tencereye alın, orta ateşte karıştırarak pişirin.",
        "Kıvam aldığında ocaktan alın, bitter çikolatayı ekleyip karıştırın.",
        "Kuplara paylaştırın, soğuduktan sonra üzerini süsleyin."
      ],
      tips: [
        "Tatlıyı sıcak sıcak kuplara döktükten sonra üzerini streç filmle kapatıp kabuk oluşmasını önleyebilirsiniz."
      ],
      calories: "1 kupluk porsiyon: yaklaşık 250 kcal"
    }
  },
  {
    id: 2,
    title: "Fırında Yoğurtlu Köfte Topları",
    image: "https://images.unsplash.com/photo-1502741338009-cac2772e18bc?auto=format&fit=crop&w=600&q=80",
    time: '30 dk',
    details: {
      summary: "Fırında yoğurtlu köfte topları, kızartma yapılmadan hazırlanan nefis bir öğle ya da akşam yemeği alternatifi. Düşük kalorili ve protein dolu!",
      ingredients: [
        "300 g kıyma",
        "1 küçük soğan (rendelenmiş)",
        "2 yemek kaşığı galeta unu",
        "1 yumurta",
        "Tuz, karabiber, kimyon",
        "Sosu için: 1 kase yoğurt, 1 diş sarımsak, 1 çay kaşığı nane",
        "Üzeri için: 1 yemek kaşığı tereyağı, 1 çay kaşığı pul biber"
      ],
      instructions: [
        "Köfte malzemelerini yoğurup minik toplar haline getirin.",
        "Yağlı kağıt serili tepsiye dizip 200°C fırında 20 dakika pişirin.",
        "Yoğurdu sarımsak ve nane ile karıştırın.",
        "Fırından çıkan köfteleri yoğurtla kaplayın, üzerine tereyağında kızdırılmış pul biber gezdirin."
      ],
      tips: [
        "Yoğurdu direkt buzdolabından çıkarmayın, oda sıcaklığında kullanın ki köfteyle buluştuğunda kesilmesin."
      ],
      calories: "1 porsiyon (5-6 köfte + sos): yaklaşık 320 kcal"
    }
  },
  {
    id: 3,
    title: "Mantarlı Arpa Şehriye Pilavı",
    image: require('../assets/whisk_storyboard1c78ddfbc402484a93b33bb8-1-700x456.png'),
    time: '30 dk',
    details: {
      summary: 'Mantarlı Arpa Şehriye Pilavı Tarifi\n\nKlasik pirinç pilavlarına lezzetli bir alternatif arıyorsanız, bu tarif tam size göre. Mantarın doyuruculuğu ve arpa şehriyenin hafifliğiyle birleşen bu pilav, ister ana yemek yanına, ister tek başına harika bir seçenek.',
      ingredients: [
        '1 su bardağı arpa şehriye',
        '200 g mantar',
        '1 küçük soğan',
        '1,5 su bardağı sıcak su',
        '2 yemek kaşığı zeytinyağı',
        'Tuz, karabiber'
      ],
      instructions: [
        'Soğanı küçük doğrayıp zeytinyağında kavurun.',
        'Doğranmış mantarları ekleyin, suyunu salıp çekene kadar pişirin.',
        'Arpa şehriyeyi ilave edip birkaç dakika kavurun.',
        'Sıcak suyu ekleyin, tuz ve karabiber serpip kapağı kapalı şekilde suyunu çekene kadar pişirin.'
      ],
      tips: [
        'Pilavı demlendirmeyi unutmayın, böylece tane tane olur.'
      ],
      calories: '1 porsiyon ≈ 180 kalori'
    }
  },
  {
    id: 4,
    title: "Nar Ekşili Nohutlu Kinoa Salatası",
    image: "https://images.unsplash.com/photo-1464306076886-debca5e8a6b0?auto=format&fit=crop&w=600&q=80",
    time: '20 dk',
    details: {
      summary: "Sağlıklı beslenmenin gözdesi kinoa, nar ekşisi ve nohudun birleşimiyle bu tarifte hem doyurucu hem de ferahlatıcı bir salataya dönüşüyor. Öğle veya akşam öğünlerinde hafif ama besleyici bir seçenek arayanlar için birebir.",
      ingredients: [
        "1 su bardağı haşlanmış kinoa",
        "1 su bardağı haşlanmış nohut",
        "10 adet cherry domates",
        "1 küçük salatalık",
        "1/2 kırmızı soğan",
        "2 yemek kaşığı zeytinyağı",
        "1 yemek kaşığı nar ekşisi",
        "Limon suyu, tuz"
      ],
      instructions: [
        "Kinoayı paketteki tarife göre haşlayın ve soğutun.",
        "Tüm malzemeleri doğrayıp geniş bir kasede karıştırın.",
        "Zeytinyağı, limon suyu ve nar ekşisini ekleyip tekrar karıştırın.",
        "Soğuk olarak servis yapın."
      ],
      tips: [
        "Salatayı 1 saat önceden hazırlayıp dolapta dinlendirirseniz malzemeler birbirine daha iyi geçer ve lezzet derinleşir."
      ],
      calories: "Bir porsiyon yaklaşık 250 kcal."
    }
  },
  {
    id: 5,
    title: "Fırında Mercimek Mücveri",
    image: "https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=600&q=80",
    time: '35 dk',
    details: {
      summary: "Kızartma derdi olmadan, fırında pişirilen bu mercimek mücveri hem doyurucu hem de oldukça sağlıklı. Vegan ve glutensiz olması sayesinde birçok beslenme planına da uyum sağlar.",
      ingredients: [
        "1 su bardağı kırmızı mercimek",
        "1 küçük havuç (rendelenmiş)",
        "1 küçük kabak (rendelenmiş)",
        "1 soğan (rendelenmiş)",
        "1 tutam maydanoz",
        "1 tatlı kaşığı kimyon",
        "1 çay kaşığı karbonat",
        "2 yemek kaşığı zeytinyağı",
        "Tuz, karabiber"
      ],
      instructions: [
        "Mercimeği yıkayıp 2 su bardağı suda yumuşayana kadar pişirin.",
        "Tüm malzemeleri karıştırın.",
        "Yağlı kağıt serilmiş tepsiye kaşıkla mücver şekli verin.",
        "180°C fırında 25–30 dakika pişirin.",
        "Ilık veya soğuk olarak servis edin."
      ],
      tips: [
        "Daha kıtır bir dış yüzey için son 5 dakikada fırının ızgara modunu kullanabilirsiniz."
      ],
      calories: "1 adet mücver yaklaşık 90 kcal."
    }
  },
  {
    id: 6,
    title: "Zencefilli Balkabağı Çorbası",
    image: "https://images.unsplash.com/photo-1506089676908-3592f7389d4d?auto=format&fit=crop&w=600&q=80",
    time: '25 dk',
    details: {
      summary: "Soğuyan havalarda içinizi ısıtacak, hem lezzetli hem de bağışıklık sisteminizi destekleyecek bir tarif arıyorsanız zencefilli balkabağı çorbası tam size göre. Hafif tatlı aroması ve baharatların uyumuyla sofralarınıza şıklık katacak bu çorba, özellikle sonbahar ve kış aylarında favoriniz olabilir.",
      ingredients: [
        "500 g doğranmış balkabağı",
        "1 küçük soğan",
        "1 diş sarımsak",
        "1 çay kaşığı rendelenmiş taze zencefil",
        "2 yemek kaşığı zeytinyağı",
        "1 su bardağı süt (isteğe göre bitkisel süt)",
        "3 su bardağı su veya sebze suyu",
        "Tuz, karabiber"
      ],
      instructions: [
        "Soğan ve sarımsağı zeytinyağında kavurun.",
        "Balkabağını ve zencefili ekleyip birkaç dakika soteleyin.",
        "Su veya sebze suyunu ekleyin, balkabakları yumuşayana kadar pişirin.",
        "Blender'dan geçirip sütü ekleyin ve 5 dakika daha kaynatın.",
        "Baharatlarla tatlandırıp sıcak servis edin."
      ],
      tips: [
        "Çorbanızı servis etmeden önce üzerine birkaç damla limon suyu ve kabak çekirdeği ekleyerek aroma ve sunum zenginliği sağlayabilirsiniz."
      ],
      calories: "Bir kase yaklaşık 120 kcal."
    }
  },
  {
    id: 7,
    title: 'Yoğurtlu Kuru Domates Mezesi',
    image: require('../assets/whisk_storyboard709117661e564e73b55e923b-700x456 (1)-min.png'),
    details: {
      summary: 'Yoğurtlu Kuru Domates Mezesi Tarifi\n\nKuru domatesin yoğun aroması ve yoğurdun ferahlığı bir araya geliyor; ortaya hem pratik hem de fark yaratan bir meze çıkıyor. Özellikle kalabalık sofralarda dikkat çekecek bu tarif, ekmek banmalık lezzetiyle akıllarda kalacak!',
      ingredients: [
        '6-7 adet kuru domates',
        '1 su bardağı süzme yoğurt',
        '1 diş sarımsak',
        '2 yemek kaşığı zeytinyağı',
        '1 tatlı kaşığı ceviz içi (isteğe bağlı)',
        '1 çay kaşığı pul biber',
        'Tuz'
      ],
      instructions: [
        'Kuru domatesleri sıcak suda 10 dakika bekletin, ardından ince ince doğrayın.',
        'Yoğurt ve ezilmiş sarımsağı karıştırın.',
        'Zeytinyağını bir tavada ısıtıp doğranmış domatesleri 2-3 dakika kavurun, pul biber ekleyin.',
        'Domatesleri yoğurtla karıştırın. Üzerine ceviz serpip soğuk servis yapın.'
      ],
      tips: [
        'Yoğurdun kesilmemesi için kavrulmuş domatesleri çok sıcak haldeyken karıştırmayın.'
      ],
      calories: '1 porsiyon ≈ 120 kalori'
    }
  }
];

const initialMessages = [
  {
    id: 1,
    text: "Elimde domates, biber, yumurta var. Sence ne yemek yapabilirim?",
    sender: 'user'
  },
  {
    id: 2,
    sender: 'ai',
    recipe: {
      title: 'Menemen Tarifi',
      ingredients: [
        '2 domates',
        '2 yeşil biber',
        '2 yumurta',
        'Tuz, yağ',
        '1 çay kaşığı tereyağı'
      ],
      instructions: [
        'Biberleri doğrayıp tavada yağ ile kavur.',
        'Domatesleri ekleyip suyunu çekene kadar pişir.',
        'Yumurtaları kırıp karıştır ve pişir.'
      ]
    }
  }
];

const aiExampleReply = {
  sender: 'ai',
  recipe: {
    title: 'Menemen Tarifi',
    ingredients: [
      '2 domates',
      '2 yeşil biber',
      '2 yumurta',
      'Tuz, yağ',
      '1 çay kaşığı tereyağı'
    ],
    instructions: [
      'Biberleri doğrayıp tavada yağ ile kavur.',
      'Domatesleri ekleyip suyunu çekene kadar pişir.',
      'Yumurtaları kırıp karıştır ve pişir.'
    ]
  }
};

// Artık backend'e değil, doğrudan OpenAI API'ye istek atılıyor. API anahtarı burada tutuluyor (güvenli değil, sadece demo için).
const OPENAI_API_KEY = "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";

const HomePage = ({ onRecipeSelect }) => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: true,
    swipeToSlide: true,
    draggable: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          draggable: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          draggable: true,
          touchMove: true,
        },
      },
    ],
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSend = async () => {
    if (!inputValue.trim()) return;
    const userMsg = {
      id: Date.now(),
      text: inputValue,
      sender: 'user'
    };
    setMessages(prev => [...prev, userMsg]);
    setInputValue("");
    setIsLoading(true);

    try {
      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${OPENAI_API_KEY}`
        },
        body: JSON.stringify({
          model: "gpt-3.5-turbo",
          messages: [
            { role: "system", content: "Sen bir yemek tarifi asistanısın. Kullanıcıdan gelen malzemelere göre sade ve kısa bir yemek tarifi öner. Sadece tarif ve malzeme listesi ver." },
            { role: "user", content: userMsg.text }
          ],
          max_tokens: 400,
          temperature: 0.7
        })
      });
      const data = await response.json();
      let aiText = data.choices?.[0]?.message?.content || "Bir hata oluştu.";
      // Basit ayrıştırma: Başlık, malzemeler, yapılış
      const lines = aiText.split('\n').map(l => l.trim()).filter(Boolean);
      let title = lines[0];
      let ingredients = [];
      let instructions = [];
      let inIngredients = false, inInstructions = false;
      for (let line of lines.slice(1)) {
        if (/malzemeler/i.test(line)) { inIngredients = true; inInstructions = false; continue; }
        if (/yapılış|hazırlanış/i.test(line)) { inIngredients = false; inInstructions = true; continue; }
        if (inIngredients) ingredients.push(line.replace(/^[-*•\d.\s]+/, ''));
        else if (inInstructions) instructions.push(line.replace(/^[-*•\d.\s]+/, ''));
      }
      if (!title) title = "Tarif";
      if (!ingredients.length) ingredients = ["Malzeme bilgisi bulunamadı."];
      if (!instructions.length) instructions = [aiText];
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        sender: 'ai',
        recipe: {
          title,
          ingredients,
          instructions
        }
      }]);
    } catch (e) {
      setMessages(prev => [...prev, {
        id: Date.now() + 2,
        sender: 'ai',
        recipe: {
          title: 'Hata',
          ingredients: [],
          instructions: ["API bağlantı hatası"]
        }
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  const popularRecipes = [
    {
      id: 1,
      title: 'Karamelli Elma Tatlısı',
      image: require('../assets/whisk_storyboard2478a1c402bf44d09a3c3e48-700x456.png'),
      details: {
        summary: 'Karamelli Elma Tatlısı Tarifi\n\nHem hafif hem gösterişli bir tatlı arıyorsanız, bu fırınsız karamelli elma tatlısı tam size göre. Özellikle sunumu ve karamel kokusuyla gönülleri fethedecek bu tarif, özel gün sofralarına da çok yakışıyor.',
        ingredients: [
          '2 adet kırmızı elma',
          '2 yemek kaşığı toz şeker',
          '1 tatlı kaşığı tereyağı',
          '1/2 çay kaşığı tarçın',
          '2 yemek kaşığı ceviz içi (isteğe bağlı)'
        ],
        instructions: [
          'Elmaları soyup halka ya da küp şeklinde doğrayın.',
          'Tavada tereyağını eritin, şekeri ekleyip karıştırarak eritin.',
          'Elmaları ve tarçını ekleyip 5-6 dakika kadar pişirin.',
          'Cevizle süsleyip ılık ya da soğuk servis edin.'
        ],
        tips: [
          'Elmaların dağılmaması için çok olgun olmayan, hafif sert elmalar tercih edin.'
        ],
        calories: '1 porsiyon ≈ 160 kalori'
      }
    },
    {
      id: 2,
      title: 'Mantarlı Arpa Şehriye Pilavı',
      image: require('../assets/whisk_storyboard1c78ddfbc402484a93b33bb8-1-700x456.png'),
      details: {
        summary: 'Mantarlı Arpa Şehriye Pilavı Tarifi\n\nKlasik pirinç pilavlarına lezzetli bir alternatif arıyorsanız, bu tarif tam size göre. Mantarın doyuruculuğu ve arpa şehriyenin hafifliğiyle birleşen bu pilav, ister ana yemek yanına, ister tek başına harika bir seçenek.',
        ingredients: [
          '1 su bardağı arpa şehriye',
          '200 g mantar',
          '1 küçük soğan',
          '1,5 su bardağı sıcak su',
          '2 yemek kaşığı zeytinyağı',
          'Tuz, karabiber'
        ],
        instructions: [
          'Soğanı küçük doğrayıp zeytinyağında kavurun.',
          'Doğranmış mantarları ekleyin, suyunu salıp çekene kadar pişirin.',
          'Arpa şehriyeyi ilave edip birkaç dakika kavurun.',
          'Sıcak suyu ekleyin, tuz ve karabiber serpip kapağı kapalı şekilde suyunu çekene kadar pişirin.'
        ],
        tips: [
          'Pilavı demlendirmeyi unutmayın, böylece tane tane olur.'
        ],
        calories: '1 porsiyon ≈ 180 kalori'
      }
    },
    {
      id: 3,
      title: 'Yoğurtlu Kuru Domates Mezesi',
      image: require('../assets/whisk_storyboard709117661e564e73b55e923b-700x456 (1)-min.png'),
      details: {
        summary: 'Yoğurtlu Kuru Domates Mezesi Tarifi\n\nKuru domatesin yoğun aroması ve yoğurdun ferahlığı bir araya geliyor; ortaya hem pratik hem de fark yaratan bir meze çıkıyor. Özellikle kalabalık sofralarda dikkat çekecek bu tarif, ekmek banmalık lezzetiyle akıllarda kalacak!',
        ingredients: [
          '6-7 adet kuru domates',
          '1 su bardağı süzme yoğurt',
          '1 diş sarımsak',
          '2 yemek kaşığı zeytinyağı',
          '1 tatlı kaşığı ceviz içi (isteğe bağlı)',
          '1 çay kaşığı pul biber',
          'Tuz'
        ],
        instructions: [
          'Kuru domatesleri sıcak suda 10 dakika bekletin, ardından ince ince doğrayın.',
          'Yoğurt ve ezilmiş sarımsağı karıştırın.',
          'Zeytinyağını bir tavada ısıtıp doğranmış domatesleri 2-3 dakika kavurun, pul biber ekleyin.',
          'Domatesleri yoğurtla karıştırın. Üzerine ceviz serpip soğuk servis yapın.'
        ],
        tips: [
          'Yoğurdun kesilmemesi için kavrulmuş domatesleri çok sıcak haldeyken karıştırmayın.'
        ],
        calories: '1 porsiyon ≈ 120 kalori'
      }
    }
  ];

  return (
    <div className="homepage-old-container">
      <header className="homepage-old-header">
        <img src={logo} alt="YemekTarifleri.Ai Logo" className="homepage-old-logo" />
        <div className="homepage-old-greeting">İyi Günler <span role="img" aria-label="eller">🙌</span></div>
        <div className="homepage-old-main-message">Bugün yemek yapmak için harika bir gün</div>
      </header>
      <main className="homepage-old-chat-area">
        <div className="chat-box">
          <div className="chat-messages">
            {messages.length > 0 && messages.map((msg, idx) =>
              msg.sender === 'user' ? (
                <div key={msg.id} className="homepage-old-chat-bubble user">
                  {msg.text}
                </div>
              ) : (
                <div key={msg.id} className="homepage-old-ai-reply">
                  <div className="homepage-old-recipe-card">
                    <h3>{msg.recipe.title}</h3>
                    <div><b>Malzemeler:</b>
                      <ul>
                        {msg.recipe.ingredients.map((item, i) => <li key={i}>{item}</li>)}
                      </ul>
                    </div>
                    <div><b>Yapılışı:</b>
                      <ol>
                        {msg.recipe.instructions.map((step, i) => <li key={i}>{step}</li>)}
                      </ol>
                    </div>
                  </div>
                </div>
              )
            )}
            {isLoading && (
              <div className="homepage-old-ai-reply">
                <div className="homepage-old-recipe-card" style={{textAlign:'center',color:'#aaa',background:'transparent',boxShadow:'none'}}>
                  <div className="chat-loading-dots">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="homepage-old-chat-input-row">
            <input
              className="homepage-old-chat-input"
              type="text"
              placeholder="Hangi malzemeleriniz var?"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <button className="homepage-old-chat-send-btn" onClick={handleSend} aria-label="Gönder">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
        </div>
      </main>
      <section className="popular-recipes-bar-home">
        <div className="popular-title-home">En Çok Yapılan Tarifler</div>
        <div className="popular-recipes-scroll-home">
          {popularRecipes.map(recipe => (
            <div className="popular-recipe-card-home" key={recipe.id} onClick={() => onRecipeSelect(recipe)}>
              <img src={recipe.image} alt={recipe.title} className="popular-recipe-img-home" />
              <div className="popular-recipe-info-home">
                <div className="popular-recipe-title-home">{recipe.title}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage; 